import { render, staticRenderFns } from "./myfavorite.vue?vue&type=template&id=af2d3804&scoped=true"
import script from "./myfavorite.vue?vue&type=script&lang=js"
export * from "./myfavorite.vue?vue&type=script&lang=js"
import style0 from "./myfavorite.vue?vue&type=style&index=0&id=af2d3804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2d3804",
  null
  
)

export default component.exports